import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";

const links = [
  { href: "#leistungen", label: "Leistungen" },
  { href: "#referenzen", label: "Referenzen" },
  { href: "#prozess", label: "Prozess" },
  { href: "#kontakt", label: "Kontakt" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 inset-x-0 z-50 glass-nav border-b transition-[padding,border-color] duration-300 ${
          scrolled ? "border-[#E4E4E7] py-3" : "border-transparent py-5"
        }`}
      >
        <div className="max-w-6xl mx-auto px-5 md:px-8 flex items-center justify-between">
          <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5">
            <img src="/logo-mark-dark.png" alt="SA Webdesign Logo" className="h-9 w-auto" />
            <span className="font-display font-semibold text-lg tracking-tight">Webdesign</span>
          </a>
          <nav className="hidden md:flex items-center gap-8" aria-label="Hauptnavigation">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="text-sm font-medium text-[#52525B] hover:text-[#0A0A0A] transition-colors duration-200"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <a
            href="#kontakt"
            data-testid="nav-cta"
            className="group inline-flex items-center gap-2 rounded-full bg-[#0A0A0A] text-white text-sm font-semibold px-5 py-2.5 hover:bg-[#2563EB] transition-colors duration-300"
          >
            Erstgespräch sichern
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5" />
          </a>
        </div>
      </header>

      <AnimatePresence>
        {scrolled && (
          <motion.a
            href="#kontakt"
            data-testid="sticky-mobile-cta"
            initial={{ y: 80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 80, opacity: 0 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            className="md:hidden fixed bottom-4 inset-x-4 z-50 flex items-center justify-center gap-2 rounded-full bg-[#2563EB] text-white font-semibold py-3.5 shadow-lg shadow-blue-600/30"
          >
            Kostenloses Erstgespräch sichern
            <ArrowRight className="w-4 h-4" />
          </motion.a>
        )}
      </AnimatePresence>
    </>
  );
}
